export default defineAppConfig({
  currency: {
    maximumFractionDigits: 2,
  },
  percent: {
    maximumFractionDigits: 0,
  },
})
